import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import testReducer from "./testSlice";

const rootReducer = combineReducers({
  me: authReducer,
  tr: testReducer,
});

export default rootReducer;
